import { HeaderOption } from '../OnboardingPortalHeader';

export type ExportButtonOption = {
    text: string;
    onClick: () => void;
};

const OnboardingPortalExportButton = ({
    t,
    onExportCSV,
    onExportExcel,
    moreOptions,
}: {
    t: (key: string) => string;
    onExportCSV: () => void;
    onExportExcel: () => void;
    moreOptions?: ExportButtonOption[];
}) => {
    return (
        <HeaderOption
            dropDownLabel={{
                text: t("onboardingPortal.exportBtn"),
                iconLeft: "download",
                iconRight: "chevron_small_down",
            }}
            options={[
                {
                    text: t("onboardingPortal.exportCsvBtn"),
                    onClick: onExportCSV,
                },
                {
                    text: t("onboardingPortal.exportExcelBtn"),
                    onClick: onExportExcel,
                },
                ...(moreOptions ?? []),
            ]}
        />
    );
};

export default OnboardingPortalExportButton;